import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "table-index-cell" }
const _hoisted_4 = { class: "table-index-cell__order" }
const _hoisted_5 = { class: "table-index-cell__id" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0 justify-center" }, "Nhóm cha", -1)
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center justify-start mb-0"
}
const _hoisted_8 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.removeItemDialogDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeItemDialogDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeItemDialogDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingDanhMucVatTu)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa nhóm vật tư "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.deletingDanhMucVatTu.ten_danh_muc), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "Chưa có nhóm vật tư nào được tạo",
      style: {"width":"100%"},
      size: "medium",
      border: true,
      data: _ctx.items,
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_word_break_column, {
          "header-title": "Tên",
          property: "ten_danh_muc",
          width: "350"
        }),
        _createVNode(_component_word_break_column, {
          "header-title": "Mã nhóm",
          property: "ma_danh_muc",
          width: "80"
        }),
        (_ctx.showNhomChaColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Nhóm cha",
              width: "130"
            }, {
              header: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx((scope) => [
                (scope.row.parent)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "justify-start d-flex align-items-center",
                      to: `/quan-ly/danh-muc-vat-tu/chi-tiet/${scope.row.parent.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.parent.ten_danh_muc), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_7, " Không có "))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "TK Kế toán",
          "min-width": "220"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.formatTkKetoan(scope.row.tk_ketoan)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_word_break_column, {
          "header-title": "Ghi chú",
          property: "mo_ta"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          width: "50",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}